import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { fetchPledges } from "../queries"

export const usePledges = ({ current }: { current: boolean }) => {
  return useSuspenseInfiniteQuery({
    queryKey: ["Pledges", { current }],
    queryFn: ({ pageParam }) => {
      return fetchPledges({
        pageParam,
        current: current,
      })
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.meta?.next?.offset,
  })
}
